import type { ToolAccess } from '../../../types/backend';

/** The admin role applies: set as required, or left as shipped on an action the policies ship behind it. */
export const roleNeeded = (a: ToolAccess, roleGated: boolean): boolean =>
  a.access_admin_role === 'required' || (a.access_admin_role === 'shipped' && roleGated);

const automationBelowAdmin = (a: ToolAccess) => a.access_aws_automation === 'l1' || a.access_aws_automation === 'l2';

/** What a change opens that only the admin role has today, in the admin's words (PS-UC-26 3c; decision 7). */
export function openings(before: ToolAccess, after: ToolAccess, roleGated: boolean): string[] {
  const opens: string[] = [];
  if (roleNeeded(before, roleGated) && !roleNeeded(after, roleGated)) {
    opens.push('Operators without the admin role will be able to use it, at the level set.');
  }
  if (after.access_jit === 'off' && before.access_jit !== 'off') {
    opens.push('Just-in-time access no longer applies to it on customers that require it.');
  }
  if (automationBelowAdmin(after) && after.access_aws_automation !== before.access_aws_automation) {
    opens.push('Operators below admin will be able to take the automation role in a customer account.');
  }
  return opens;
}

/** Lowering ValidateRoleAccess's write use alone does not open it: its only L1 permit is read-only (F3). */
export const needsToolWideLowering = (actionId: string): boolean => actionId === 'customers:ValidateRoleAccess';
